export default __webpack_public_path__ + "static/media/bancorio-logo.49014f80.png";